import { useCallback } from 'react';

import { DEFAULT_PRODUCT_QUANTITY } from '../../constant';
import { mappingProductsListPayload } from './useMappingProductsList';

export const useMappingFreeGiftData = () => {
  return useCallback((freeGiftsList) => {
    let results = [];

    const promotionTypeFreeGift = freeGiftsList.length ? freeGiftsList.reduce((list, freeGiftItem) => (
      list =
        [
          ...list,
          ...(
            freeGiftItem.items || []
          )
        ]
    ), []) || [] : [];

    if (promotionTypeFreeGift.length && promotionTypeFreeGift.some((item) => item.HasBOPISOption)) {
      promotionTypeFreeGift.forEach((freeGiftItem) => results.push({
        ...mappingProductsListPayload({
          productId: freeGiftItem.ProductId || '',
          variantId: freeGiftItem.VariantId || '',
          BOPISThreshold: freeGiftItem.BOPISThreshold,
          lineQuantity: DEFAULT_PRODUCT_QUANTITY
        })
      }));
    }

    return results;
  }, []);
};